import React, { Fragment } from 'react';
import { useQuery, useMutation } from '@apollo/react-hooks';
import { gql } from 'apollo-boost';
import Spinner from 'react-spinkit';
import { Link, useParams } from 'react-router-dom';

import Header from '../components/header';
import { USER_CART_ITEMS } from './cart';

const GET_ALL_CARTEGORIES = gql`
  query GET_ALL_CARTEGORIES {
    categories {
      id
      name
    }
  }
`;

const GET_ALL_PRODUCTS = gql`
  query GET_ALL_PRODUCTS($categoryId: String) {
    products(categoryId: $categoryId){
      id
      name
      price
      image_url
      description
    }
  }
`;

const ADD_TO_CART = gql`
  mutation ADD_TO_CART($quantity: Int!, $productId: String) {
    addToCart(
      data: {
        quantity: $quantity,
        productId: $productId
      }
    ) {
      id
      quantity,
      product {
        name
        price
        image_url
      }
    }
  }
`;
const Category = () => {
  const { categoryId } = useParams();
  const [addToCart, { loading: mutationLoading }] = useMutation(ADD_TO_CART);

  const { loading: categoryLoading, error: categoryError,  data: categoriesData  } = useQuery(GET_ALL_CARTEGORIES);
  const { loading, error, data } = useQuery(GET_ALL_PRODUCTS, {
    variables: {
      categoryId
    }
  });

  if (loading) return (<Spinner name="circle" />)
  if (error) return "ERROR"

  const addItemToCart = async (product) => {
    try {
      const response = await addToCart({
        variables: {
          productId: product.id,
          quantity: 1
        },
        update: (cache, { data: { addToCart } }) => {
          const data = cache.readQuery({ query: USER_CART_ITEMS });
          const index = data.cart.findIndex(item => {
            return item.id === addToCart.id
          });
          if (index !== -1) {
            data.cart.map(item => {
              if (item.id === addToCart.id) {
                item.quantity += 1;
              }
            })
          } else {
            data.cart.push(addToCart);
          }
          cache.writeQuery({ query: USER_CART_ITEMS, data });
        }
      });
    } catch (err) {
      console.log(err.message);
    }
  }

    return (
      <Fragment>
        <Header />
        <div className="wrapper">
          <section className="breadcrumb">
            <div className="links">
              <span>Home</span> /
              <span> Products</span>
            </div>
            <h2>Products</h2>
          </section>

          <section className="filters">
            <h2>Filter By Category</h2>
            <ul className="filters__category">
              {/* <select className="filters__category__select-input" name="categories" id="">
              </select> */}
              {categoriesData.categories ? categoriesData.categories.map(category => {
                return (
                  <li key={category.id}><Link to={`/category/${category.id}`}>{category.name}</Link></li>
                )
              }) : ''}
            </ul>
            {/* <div className="filter__price">
              <h2>Choose Price</h2>
              <input type="range" name="Choose Price" min="1" id="Price"/>
            </div> */}
          </section>

          <section className="category__products">
            <h2>Shop</h2>
            {/* <div className="products__card">
              <figure>
                <img src={shoe} alt="" className="products__img" />
              </figure>
              <p className="products__name">Bose Headphones</p>
              <p className="products__price">$230</p>
              <button className="btn products__btn">Add To Cart</button>
            </div> */}
            {data.products ? data.products.map(product => {
              return (
                <div key={product.id} className="products__card">
                  <figure>
                    <img src={product.image_url} alt="" className="products__img" />
                  </figure>
                  <p className="products__name"><Link to={`/single/${product.id}`}>{product.name}</Link></p>
                  <p className="products__price">${product.price}</p>
                  <button className="btn products__btn" onClick={() => addItemToCart(product)}>Add{mutationLoading && 'ing'} To Cart</button>
                </div>
              )
            }) : "There are no Products Available for this category"}

          </section>
        </div>
      </Fragment>
    )
}

export default Category;
export { ADD_TO_CART };